module.exports = __webpack_public_path__ + "img/no_view.33ec60d9.svg";